export default {
  Confirm: 'Confirmar',
  Cancel: 'Cancelar',
  'The minimum time length is xxxs!': '¡El tiempo mínimo es {{num}}s!',
  'The maximum time length is 50s!': '¡El tiempo máximo es 50s!',
  'Online service, no download required': 'Edición en línea, no se necesita descargar',
  'Add up to 20MB file': 'El tamaño máximo del archivo es de 20 MB',
  'Support common formats': 'Admite formatos comunes',
  'Best for general editing requirements': 'Resuelve tus necesidades de edición diarias',
  '0 second wait': '0 segundos de espera',
  'No size limits': 'Sin límite de tamaño de archivo',
  'Support 1000+ formats': 'Admite más de 1000 formatos',
  'Stable processing': 'Procesamiento estable',
  'Get access to HitPaw Toolkit!': '¡Acceder a HitPaw Toolkit!',
  'Support cut, crop & rotate, adjust, speed, add music, stop motion, etc.':
    'Proporciona funciones como cortar, rotar y reflejar, ajustar color, cambiar velocidad y agregar música.',
  'The easiest video editing software for beginners':
    'El mejor software de edición para principiantes.',
  'Remove watermark from videos and images in simple clicks':
    'Solo unos clics para quitar marcas de agua de videos e imágenes',
  'TRY IT FREE': 'Prueba gratis',
  'BUY NOW': 'Comprar ahora',
  'Analyzing successfully! Your file is larger than 100 MB which cannot be edited by HitPaw Online, please ':
    '¡Analizado con éxito! Tu archivo tiene más de 100 MB y HitPaw Online no puede editarlo, ',
  'download the video': 'descarga el vídeo',
  'and then use HitPaw Toolkit to proceed.': ' y luego usa HitPaw Toolkit para continuar.',
  'Cut 10 video fragments at most. Get HitPaw Toolkit for more features.':
    'Se puede cortar un máximo de 10 fragmentos. Obtenga HitPaw Toolkit para obtener más funciones.',
  'Max file size for videos is 20 MB. Get HitPaw Toolkit for big file.':
    'El tamaño del archivo no puede ser mayor que 20MB. Obtenga HitPaw Toolkit para obtener más funciones.',
  'The minimum time length is 1s! Get HitPaw Toolkit for more features.':
    '¡El tiempo mínimo es 1s! Obtenga HitPaw Toolkit para obtener más funciones.',
  'Add 3 videos at most. Get HitPaw Toolkit for more features.':
    'Se puede agregar un máximo de 3 vídeos. Obtenga HitPaw Toolkit para obtener más funciones.',
  'This format is not supported currently.': 'Este formato no es compatible actualmente.',
  'This format is not supported currently. Get HitPaw Toolkit for more formats':
    'Este formato no es compatible actualmente. Obtenga HitPaw Toolkit para obtener más funciones.',
  'Processing failed. Get HitPaw Toolkit for stable processing.': 'Falló al generar el vídeo.',
  'Failed to load!  Get HitPaw Watermark Remover for stable processing.': '¡Falló al cargar!',
  'Are you sure you want to delete it?': '¿Estás seguro de eliminarlo?',
  'Failed to extract the audio!': '¡No se pudo extraer el audio!',
  'Coming Soon': 'Próximamente',
  'Learn more': 'Aprender más',
  'Add up to 2 files. Get HitPaw Toolkit for big file.':
    'Agregar hasta 2 archivos. Obtenga HitPaw Toolkit para obtener más funciones.',
  Download: 'Descargar',
  'Try Again': 'Intentar otra vez',
  Failed: 'Falló',
  'Get Started': 'Empezar a editar',
  Start: 'Inicio',
  End: 'Final',
  Export: 'Exportar',
  'Your audio is ready!': '¡Tu audio está listo!',
  'Download Audio': 'Descargar audio',
  YES: 'Sí',
  'Export Failed': 'Exportación falló',
  'Error occurs, the file cannot be added': 'Ocurre un error, el archivo no se puede agregar',
  'Support merging audio files at most':
    'Admite la combinación de {{num}} archivos de audio como máximo',
  'Are you sure you want to delete this task?': '¿Estás seguro de que deseas eliminar esta tarea?',
  Processing: 'Procesando',
  "Don't forget to download your file, it will be deleted after 24 hours.":
    'No olvides descargar tu archivo, estará eliminado 24 horas después.',
  Uploading: 'Subiendo',
  'Go Edit': 'Editar',
  'Generate Files Successfully!': '¡Archivos se generaron con éxito!',
  'Your order is being paid...': '¿Ha pagado su pedido?',
  'Not yet': 'Todavía No',
  'Payment completed': 'Sí',
  downloadFail: 'No se pudo descargar, intente nuevamente.',
  videoReady: '¡Su foto animada está lista!',
  'Download Without Watermark': 'Descargar Sin Marca de Agua',
  'Download As GIF': 'Descargar En GIF',
  'Download With Watermark': 'Descargar Con Marca de Agua',
  'Upload New Photo': 'Subir Nueva Foto',
  ///////
  'Upgrade to access HitPaw Online Pro Features.':
    'Actualizar para acceder a las funciones de Hitpaw Online Pro.',
  'Free account cannot upload image size that exceeds 2M.':
    'La cuenta gratuita no puede cargar el tamaño de la imagen que supera los 2M.',
  'Free account cannot upload more than 6 images.':
    'La cuenta gratuita no puede subir más de 6 imágenes.',
  'No Image Size Limits': 'Sin Límites de Tamaño de Imagen',
  'Unlimited Image Uploads': 'Imágenes Cargas Ilimitadas',
  'Download HD Image with No Watermark': 'Descargar Imagen HD Sin Marca de Agua',
  'Download Video as GIF': 'Descargar Videos en GIF',
  'More Privileges': 'Más Privilegios',
  Monthly: 'Mensualmente',
  Yearly: 'Anualmente',
  'Cancel auto-renewable subscription anytime.':
    'Cancelar suscripción automática de renovación en cualquier momento.',
  'Login to Start': 'Iniciar Sesión para Empezar',
  'Buy Now': 'Compra Ahora',
  'Network Error': 'Errores de red',
  'Connection server failed.': 'El servidor de conexión falló.',
  Month: 'Mes',
  priceMonth: '9.99€',
  priceYear: '4.99€',
  'HitPaw Video Converter': 'HitPaw Video Converter',
  'The upload video size cannot exceed 20MB. Download HitPaw Video Converter for more features.': 'El tamaño de video cargado no puede exceder los 20 MB. Descarga HitPaw Video Converter para obtener más funciones.',
  'The upload video size cannot exceed 500MB. Download HitPaw Video Converter for more features.': 'El tamaño de video cargado no puede exceder los 500 MB. Descarga HitPaw Video Converter para obtener más funciones.',
  'The upload image resolution cannot exceed 16 megapixel. Download HitPaw Video Converter for more features.':  'La resolución de imagen cargada no puede exceder los 16 megapíxeles. Descarga HitPaw Video Converter para obtener más funciones.',
  'The batch processing function is only available in the desktop software. Download HitPaw Video Converter for more features.': 'La función de procesamiento por lotes solo está disponible en el software de escritorio. Descarga HitPaw Video Converter para obtener más funciones.',
  'The number of files you processed today has reached the upper limit of 300. Download HitPaw Video Converter for more features.': 'El número de archivos que ha procesado hoy ha alcanzado el límite superior de 300. Descarga HitPaw Video Converter para obtener más funciones.',
  'Download desktop version to batch process large files with no size limit': 'Descargar la Versión de Escritorio para Procesar los Archivos Grandes SIN Limitación de Tamaño Por Lotes',
  'Batch convert video and audio files to 1000+ formats with 120X faster speed': 'Convertir por lotes los archivos de video y audio a más de 1,000 formatos a una velocidad 120 veces superior',
  'Download and save videos from 10000+ websites, such as YouTube, TikTok, Instagram, etc.': 'Descargar y guardar videos de 10,000+ sitios web como YouTube, TikTok, Instagram, etc.',
  'Built-in rich video editing features: merge, cut, crop, watermark, etc.': 'Amplias funciones de edición de video integradas: unir, cortar, recortar, marca de agua, etc.',
  'Convert Apple Music to MP3 with DRM removed (Windows version only)': 'Convertir Apple Music a MP3 sin DRM (Sólo la versión para Windows)',
}
